import _ from "lodash";
import React, {Component} from "react";
import {connect} from 'react-redux';
import {withFirebase} from 'react-redux-firebase';
import {Link, withRouter} from "react-router-dom";

// @material-ui/core components
import withWidth from '@material-ui/core/withWidth';
import withStyles from "@material-ui/core/styles/withStyles";
import LinearProgress from "@material-ui/core/LinearProgress";
// import Hidden from "@material-ui/core/Hidden";
import Typography from '@material-ui/core/Typography';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

import {getPollResults, votePoll, getRandPoll, getPollsCreatedByUname} from '../../actions';
import LoadingSpinner from 'utils/LoadingSpinner/';

import logo from "assets/img/logo.png";
import logo500 from "assets/img/logo-p-500.png";
import ShareSection from "./ShareSection.js";
import {baseline_votes, curatedPollsUids} from "./boostVotes";

import answerPollStyle from "assets/jss/material-kit-react/views/pollTemplateSections/answerPollStyle.jsx";

class PollSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAnsId: '',
      poll_results: '',
      loading: false,
      voteAnsCurPercentages: [],
      loadingPoll: true,
      extraQHeight: null,
      // ansHeight: null, // could set this also? TODO
      nextPollSameCategory: '',
    };
  }

  componentWillMount() {
    this.props.getRandPoll();
  }

  componentDidMount() {
    this.getCuratedPollsByThisUser();
    // this used to work here, now that using state data it doesnt always
    const {answers} = this.props.poll.data;
    if (answers) {
      this.initAnswerPercentages();
    }
    this.getQuestionDivSize();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  componentDidUpdate(prevProps, prevState) {
    // this.initAnswerPercentages();
    const {poll_results} = this.state;
    const inPrevProps = (!_.isEmpty(prevProps.poll.results));
    const inProps = (!_.isEmpty(this.props.poll.results));
    const firstResultsLoad = (!inPrevProps && inProps);
    const resultsLoadedAgain = (poll_results === null && (prevProps.poll.results.last_vote !== this.props.poll.results.last_vote));

    if (firstResultsLoad || resultsLoadedAgain) {
      this.setAnsPercentages(this.props.poll.results);
      // start timer now, not in DidMount
      this.timer = setTimeout(() => this.progress(2), 20);
      this.setState({
        poll_results: this.props.poll.results,
        loading: false,
      });
    }

    // NOTE we dont want next poll to link to the same page!
    // so if we have a new rand poll, and its equal to cur page, get another rand one!
    if (prevProps.poll !== this.props.poll) {
      const {random, randomPollLoading} = this.props.poll;
      const curPagePaths = window.location.pathname.split('/');
      const curPageHash = curPagePaths[curPagePaths.length-1];
      if (curPageHash === random.hash && !randomPollLoading) {
        console.log("rand == current! find another rando");
        this.props.getRandPoll();
      }
    }

    this.setNextCategoryPolls(prevProps);;
  }

  getCuratedPollsByThisUser() {
    // TODO QUESTION set expiration time limit for next polls??
    // https://www.sohamkamani.com/blog/javascript-localstorage-with-ttl-expiry/
    // TODO QUESTION remove session storage if skips two polls in a row??
    const {getPollsCreatedByUname, poll} = this.props;
    const cb_uid = poll.data.created_by.user_id;

    const nextPollsFromSeshStr = window.sessionStorage.getItem(`nxtphash${cb_uid}`);
    if (!nextPollsFromSeshStr && curatedPollsUids.includes(cb_uid)) {
      getPollsCreatedByUname(poll.data.created_by.username);
    } else if (nextPollsFromSeshStr) {
      this.getNextPollFromSessionStorage(cb_uid);
    }
  }

  setNextCategoryPolls(prvProps) {
    const {poll} = this.props;
    const createdByInProps = (!_.isEmpty(poll.created_by));
    // if new list of polls created by this user
    if (createdByInProps && prvProps.poll.created_by !== poll.created_by) {
      const cb_uid = poll.data.created_by.user_id;
      // if poll is one of our curated content users (by category) -- duplicate check, but thats okay
      if (curatedPollsUids.includes(cb_uid)) {
        const nextPollsFromSeshStr = window.sessionStorage.getItem(`nxtphash${cb_uid}`);
        // if next polls not saved to local storage -- also duplicate check
        if (!nextPollsFromSeshStr) {
          // CREATE SESH STORAGE!! :)
          let poll_hashes = _.shuffle(poll.created_by.polls.map(poll => poll.poll_hash));
          // remove current poll from next polls list
          poll_hashes = _.without(poll_hashes, poll.data.poll_hash);
          const nextPoll = poll_hashes.pop();
          // console.log('set next poll -> ', nextPoll);
          this.setState({nextPollSameCategory: nextPoll});
          window.sessionStorage.setItem(`nxtphash${cb_uid}`, JSON.stringify(poll_hashes));
          // console.log('SET SESSION STORAGE');
        }
      }
    }
  }

  getNextPollFromSessionStorage(cb_uid) {
    // console.log('GOT SESSION STORAGE');
    const nextPollsFromSeshStr = window.sessionStorage.getItem(`nxtphash${cb_uid}`);
    if (nextPollsFromSeshStr) {
      let nextPollsFromSesh = JSON.parse(nextPollsFromSeshStr);
      // NOTE order is important here!! if remove after nextPoll popped, will enter infinite loop for the user
      if (nextPollsFromSesh.length === 0) {
        window.sessionStorage.removeItem(`nxtphash${cb_uid}`);
      } else {
        const nextPoll = nextPollsFromSesh.pop();
        // console.log('set next poll -> ', nextPoll);
        this.setState({nextPollSameCategory: nextPoll});
        window.sessionStorage.setItem(`nxtphash${cb_uid}`, JSON.stringify(nextPollsFromSesh));
      }
    }
  }

  // NOTE TODO this is hacky!!! make it much cleaner...
  // not worth time now tho, might change this?
  getQuestionDivSize() {
    const {extraQHeight} = this.state;
    const {width} = this.props;

    const qDivHeight = document.getElementById('poll').firstChild.clientHeight;

    let qpadding = 0;
    let acceptableHeightBarrier = 150;
    // NOTE height for each line for the question is ~67 pixels
    let approxOKDivHeight = 67 * 2;
    if (width === 'xs') {
      acceptableHeightBarrier = 215;
      // NOTE for mobile, still looks ok with 3 lines... not just 2
      approxOKDivHeight = 67 * 3;
    }

    // only add padding if > 2 lines (or > 3 lines mobile)
    if (qDivHeight > acceptableHeightBarrier) {
      const extraLineHeight = (qDivHeight - approxOKDivHeight) / 65;
      // the numbers aren't exact, on purpose, so we round down the approximation
      // given we limit to length of chars in the question, approximating is fine.
      // this method gives more flexibility, in case pixels are slightly off...
      const extraQLines = Math.floor(extraLineHeight);
      qpadding = extraQLines * 67;
    }

    if (extraQHeight === null) {
      this.setState({extraQHeight: qpadding});
    } else if (extraQHeight !== qpadding) {
      this.setState({extraQHeight: qpadding});
    }
  }

  initAnswerPercentages() {
    const {answers} = this.props.poll.data;
    if (answers) {
      if (_.isEmpty(answers[0]['completed'])) {
        // init each answer to 0% animation completed
        this.setState({
          voteAnsCurPercentages: answers.map(item => ({ ...item, completed: 0}))
        });
      }
    }
  }

  resetAnimations() {
    const {voteAnsCurPercentages} = this.state;
    this.setState({
      voteAnsCurPercentages: voteAnsCurPercentages.map(item => ({ ...item, completed: 0}))
    });
    setTimeout(() => {
      this.timer = setTimeout(() => this.progress(2), 20);
    }, 350);  // in milliseconds
  }

  resetVoteData() {
    const {answers} = this.props.poll.data;
    this.setState({
      selectedAnsId: '',
      poll_results: null,
      voteAnsCurPercentages: answers.map(item => ({ ...item, completed: 0}))
    });
    // this.props;
    // return _.omit(state, action.payload);
    // console.log('hmmmmm, reset anime');
  }

  progress(completion) {
    const {answers} = this.props.poll.data;
    const {voteAnsCurPercentages} = this.state;
    let done = 0;
    this.setState({
      voteAnsCurPercentages: voteAnsCurPercentages.map((item, i) => {
        const { completed: current } = voteAnsCurPercentages[i];
        const { ansPercent: max } = item;
        if (current + completion >= max) {
          done += 1;
        }
        return {
          ...item,
          completed: Math.min(current + completion, max),
        };
      }),
    });
    if (done < answers.length) {
      this.timer = setTimeout(() => this.progress(2), 20);
    }
    // TODO DEBUG the timer on loop is creating a memory leak???
    // else if (done === answers.length) {
    //   setTimeout(() => {
    //     done = 0;
    //     this.resetAnimations();
    //   }, 4000);  //4 seconds
    // }
  }

  handleVote(_pId, _pHash) {
    const {selectedAnsId} = this.state;
    if (selectedAnsId) {
      this.setState({loading: true});
      const {votePoll, getPollResults, auth, poll} = this.props;
      const token =  auth.uid ? auth.uid : 'ANONYMOUS';
      const vote_id = poll.vote_results ? poll.vote_results.vote_id : null;
      const voteData = {
        poll_id: _pId,
        answer_id: selectedAnsId,
        token,
        // using field below replaces the last vote with an updated answer.
        vote_id,
      };
      votePoll(voteData, () => getPollResults(_pHash));
      // console.log('vote data', voteData);
    }
  }

  handleVoteBtnClick(_aid) {
    const {poll_results} = this.state;
    if (!poll_results && !this.props.previewPoll) {
      this.setState({selectedAnsId: _aid});
    }
  }

  sumFakeVotes(p_hash){
    const fake_votes = baseline_votes[p_hash];
    const sumFakes = Object.keys(fake_votes).reduce((sum, ans_id) =>
      sum + parseInt(fake_votes[ans_id] || 0), 0);
    // console.log('sum of Fake Votes::: ', sumFakes);
    return sumFakes;
  }

  setAnsPercentages(ansResults){
    // creates a copy of the answers, with the percentages for each one
    // sets this to the state
    const {voteAnsCurPercentages} = this.state;
    const totalRealVotes = ansResults.poll_votes;
    const this_poll_hash = this.props.history.location.pathname.replace("/poll/", "");
    const doesThisPollHaveFakeVotes = this_poll_hash in baseline_votes;
    const totalFakeVotesForThisPoll = doesThisPollHaveFakeVotes ? this.sumFakeVotes(this_poll_hash) : 0

    const withPercentPerAnswer = voteAnsCurPercentages.map( (item) => {
      const fake_votes = doesThisPollHaveFakeVotes ? baseline_votes[this_poll_hash][item.ans_id] : 0;
      if (!_.isEmpty(ansResults.answers[item.ans_id])) {
        // return ({ ...item, ansPercent: ((ansResults.answers[item.ans_id].votes/ansResults.poll_votes)*100.0).toFixed(2)});
        const realVotes =  ansResults.answers[item.ans_id].votes;
        const combinedVotes = realVotes + fake_votes;
        const combinedTotalVotes = totalRealVotes + totalFakeVotesForThisPoll;
        return (
          { ...item,
            ansPercent: Math.round((combinedVotes/combinedTotalVotes)*100.0),
            numAns: combinedVotes
          }
        );
      } else if (fake_votes > 0) { // only fake votes, no real ones
        return (
          { ...item,
            ansPercent: Math.round((fake_votes/totalFakeVotesForThisPoll)*100.0),
            numAns: fake_votes
          });
      } else {  // no fake or real votes
        return ({...item, ansPercent: 0, numAns: 0});
      }
    });
    this.setState({voteAnsCurPercentages: withPercentPerAnswer});
  }

  renderAnswers() {
    const {classes, previewPoll, poll} = this.props;
    const {selectedAnsId, loading, poll_results} = this.state;
    let answerButtons;

    if (loading) {
      answerButtons = <LoadingSpinner />;
    } else if (poll_results) {
      const {voteAnsCurPercentages} = this.state;
      // updated_results = this.setAnsPercentages(_answers, poll_results);
      answerButtons = voteAnsCurPercentages.map( (ans) => {
        const isSelected = (ans.ans_id === selectedAnsId);
        return (
         <div
           onClick={() => this.handleVoteBtnClick(ans.ans_id)}
           key={ans.ans_id}
         >
           <div style={{flexGrow: 1}}>
             <LinearProgress variant="determinate" value={ans.completed} />
           </div>
           <div className={`${classes.pollChoiceDiv} ${isSelected ? classes.selected : ''}`}>
             <div style={{width: "80%"}}>
               <Typography className={`${classes.pollChoiceTxt} ${isSelected ? classes.selectedTxt : ''}`}>
                 {`${ans.answer}`}
               </Typography>
             </div>
             <div style={{width: "20%"}}>
               <Typography style={{fontSize: 18}} className={`${classes.pollChoiceTxt} ${isSelected ? classes.selectedTxt : ''}`}>
                 {`${ans.completed}% (${ans.numAns})`}
               </Typography>
             </div>
           </div>
         </div>
        )
      });
    } else {
      const answers = previewPoll ? previewPoll.data.answers : poll.data.answers;
      // const {answers} = this.props.poll.data;
      answerButtons = answers.map( (ans) => {
        const isSelected = (ans.ans_id === selectedAnsId);
        const isSelectedClass = isSelected ? classes.selected : '';
        const isDisabledClass = this.props.previewPoll ? classes.disableLink: '';
        return (
          <div
            onClick={() => this.handleVoteBtnClick(ans.ans_id)}
            className={`${classes.pollChoiceDiv} ${isSelectedClass} ${isDisabledClass}`}
            key={ans.ans_id}
          >
            <Typography className={`${classes.pollChoiceTxt} ${isSelected ? classes.selectedTxt : ''}`}>
              {`${ans.answer}`}
            </Typography>
          </div>
        )
      });
    }
    return answerButtons;
  }

  renderVoteBtn(_pId, _pHash) {
    const {classes} = this.props;
    const {selectedAnsId, poll_results, loading} = this.state;

    if (!poll_results && !loading) {
      return (
        <GridItem xs={10} sm={8}>
          <a
            onClick={() => this.handleVote(_pId, _pHash)}
            className={`${classes.submitVoteBtn} ${(!selectedAnsId) ? classes.btnDisabled : ''}`}
          >
            Submit Vote
          </a>
        </GridItem>
      );
    } else {
      return <GridItem xs={12} sm={10} md={10}></GridItem>
    }
  }

  renderSkipBtn() {
    const {classes} = this.props;
    const {selectedAnsId, poll_results, loading, nextPollSameCategory} = this.state;
    const {random, randomPollLoading} = this.props.poll;
    const rpHash = !randomPollLoading ? random.hash : '';
    const nextPollHash = nextPollSameCategory ? nextPollSameCategory : rpHash;

    const isBtnDisabled = this.props.previewPoll || selectedAnsId;

    if (!poll_results && !loading) {
      return (
        <GridItem xs={10} sm={8}>
          <Link to={`/poll/${nextPollHash}`} className={`${classes.submitVoteBtn} ${isBtnDisabled ? classes.btnDisabled : ''}`} >
            Skip Poll
          </Link>
        </GridItem>
      );
    }
    return <GridItem xs={12} sm={10} md={10}></GridItem>
  }

  renderResultsBtns() {
    const {poll_results, nextPollSameCategory} = this.state;
    const {random, randomPollLoading} = this.props.poll;
    const rpHash = !randomPollLoading ? random.hash : '';
    const nextPollHash = nextPollSameCategory ? nextPollSameCategory : rpHash;
    if (poll_results) {
      return (
        <GridItem xs={10} sm={10} md={10}>
          <div style={{width: "100%", alignItems: "center", justifyContent: "center", display: "flex"}}>
            <Button style={{marginRight: 10}} color="primary" size="lg" onClick={()=>this.resetVoteData()} >
              Change Vote
            </Button>
            <Button color="primary" size="lg">
              <Link to={`/poll/${nextPollHash}`} style={{color: 'inherit'}} >
                Next Poll
              </Link>
            </Button>
          </div>
        </GridItem>
      );
    }
  }

  renderPoll(sectionHeight) {
    const {classes, previewPoll, poll} = this.props;
    const pollToRender = previewPoll ? previewPoll : poll;
    const pollId = previewPoll ? '0' : poll.data.poll_id;
    const pollHash = previewPoll ? '#preview' : poll.data.poll_hash;

    return (
      <div className={classes.shadowSection} style={{height: sectionHeight}}>
        <GridContainer justify="space-around" direction="column" alignItems="center">
          <GridItem id="poll" className={classes.pollAnchor} xs={10} sm={10} md={10}>
              <div className={classes.pollChoices}>
                {this.renderAnswers()}
              </div>
          </GridItem>
          {this.renderVoteBtn(pollId, pollHash)}
          {this.renderSkipBtn()}
          {this.renderResultsBtns()}
          <GridItem xs={12} sm={10} md={10}>
            <div className={classes.logoContain}>
              <img
                src={logo}
                srcSet={`${logo500} 500w, ${logo} 978w`}
                sizes="150px"
                alt="Poll Pals"
                className={classes.tinyLogo}
              />
              <div className={classes.phrase}>You Are What You Answer!</div>
              {/* QUESTION do I need trademark? <div className={classes.phrase}>You Are What You Answer!®</div> */}
            </div>
          </GridItem>
            <ShareSection addThisLoaded={this.props.addThisLoaded} />
        </GridContainer>
      </div>
    );
  }

  render() {
    const {classes, previewPoll, poll} = this.props;
    const pollToRender = previewPoll ? previewPoll : poll;

    if (pollToRender.loading || _.isEmpty(pollToRender.data)) {
      return <LoadingSpinner />;
    }

    // //Init styles assumes max 3 answers
    // //TODO QUESTION Can I inject this back into the jsx??
    // let pollCardShadowSection = classes.shadowSection;
    // if (answers.length > 3) {
    //   const numExtraAns = answers.length - 3;
    //   const extraHeight = numExtraAns * 75;
    //   pollCardShadowSection['height'] += extraHeight;
    // }
    // // TODO QUESTION continued. this hack works for now
    let newShadowHeight = 630;
    let newSectionHeight = 520;
    if (pollToRender.data.answers.length > 2) {
      const numExtraAns = pollToRender.data.answers.length - 2;
      // const extraHeight = numExtraAns * 75; //add 5 for the animation
      const extraHeight = numExtraAns * 18;
      newShadowHeight += extraHeight;
      newSectionHeight += extraHeight;
    }
    if (this.state.extraQHeight) {
      newShadowHeight += this.state.extraQHeight;
      newSectionHeight += this.state.extraQHeight;
    }

    return (
      <div className={classes.pollSection} style={{height: newSectionHeight}}>
        {/* <Hidden xsDown> */}
          {this.renderPoll(newShadowHeight)}
        {/* </Hidden>
        <Hidden smUp>
          {this.renderPoll(newShadowHeight)}
        </Hidden> */}
      </div>
    );
  }
}

const pageWithStylesAndFirebase = withStyles(answerPollStyle)(withFirebase(PollSection));

function  mapStateToProps(state) {
  return {
    auth: state.firebase.auth,
    poll: state.poll,
  }
}

export default withWidth()(withRouter(connect(mapStateToProps, {
  getPollResults, votePoll, getRandPoll, getPollsCreatedByUname
})(pageWithStylesAndFirebase)));



// WEBPACK FOOTER //
// ./src/views/PollTemplate/PollSection.js